import { Component, OnInit, Inject, Input, Output, EventEmitter } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef, MatDialogConfig } from '@angular/material/dialog';
import { ErrorcontrolService } from 'basecomponents';
import { MessageError } from 'base-models';
import { getLocaleId } from '@angular/common';


@Component({
  selector: 'app-sliderdlg',
  templateUrl: './sliderdlg.component.html',
  styleUrls: ['./sliderdlg.component.scss']
})
export class SliderDlgComponent implements OnInit {
  /**
   * name to identify the class
   */
  TAG: string = "SliderDlgComponent";
  title: string = "Range";
  titlesub: string = "";
  alertmessage: MessageError | string;
  public dialogRef: MatDialogRef<any>;

  @Input() range_title:string="Range";
  @Input() okActionText:string="Ok";
  @Input() slider_step=0.1;
  @Input() slider_max=100;
  @Input() slider_min=0;
  @Input() comments=null; 
  @Input() formatOptions={locale:"en-US",maximumFractionDigits:2,minimumFractionDigits:2}; 



   /**
   * event raised when an element is selected
   */
    @Output() selectedEvent: EventEmitter<any> = new EventEmitter();
  
  //slider
  rangeValues: number[] = [-10,100];
  range_max="100";
  range_min="0";

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.formatOptions.locale=navigator.language;
    if (data != null) {
      if (data.title) {
        this.title = data.title;
      }
      if (data.titlesub) {
        this.titlesub = data.titlesub;
      }
      if (data.range_title) {
        this.range_title = data.range_title;
      }     
      
      if (data.formatOptions) {
        this.formatOptions = data.formatOptions;
      }        
      if (data.rangeValues) {
        this.rangeValues = data.rangeValues;        
      }   
      if (data.slider_step) {
        this.slider_step = data.slider_step;
      }
      if (data.slider_max) {
        this.slider_max = data.slider_max;
      }      
      if (data.slider_min) {
        this.slider_min = data.slider_min;
      }      
      if (data.okActionText) {
        this.okActionText = data.okActionText;
      } 
      if (data.comments) {
        this.comments = data.comments;
      } 

      this.formatRange();

    }  
    
  }

  ngOnInit() {
  }
  showerror(message: string, err?: any) {
    this.alertmessage = ErrorcontrolService.basichandleError(message, err, null, this.TAG);
  }

  isvalid() {
    return true;
  }

  okaction() {
    let res: any;
    let min=this.rangeValues[0];//formModel.minZoom;
    let max= this.rangeValues[1];
    res={min:min,max:max};
    this.selectedEvent.emit(res);
    //this.dialogRef.close(res);
  }

  private formatRange(){
    this.range_min=this.slider_min.toLocaleString(this.formatOptions.locale, {
      minimumFractionDigits:this.formatOptions.minimumFractionDigits,       
      maximumFractionDigits: this.formatOptions.maximumFractionDigits,  
   });
    this.range_max=this.slider_max.toLocaleString(this.formatOptions.locale, {
      minimumFractionDigits: this.formatOptions.minimumFractionDigits,      
      maximumFractionDigits:this.formatOptions.maximumFractionDigits, 
   });   
  }

  public static openModal(dialog: MatDialog, dialogData?: any, width:string="400px",autoFocus=true): MatDialogRef<SliderDlgComponent> {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.disableClose = false;
    dialogConfig.autoFocus = autoFocus;
    dialogConfig.width = width;
    dialogConfig.data = dialogData;

    let dialogRef: MatDialogRef<SliderDlgComponent>;
    dialogRef = dialog.open(SliderDlgComponent, dialogConfig);
    //dialogRef.componentInstance.dialogRef = dialogRef;
    return dialogRef;
  }


  formatLabel(value: number) {
    if (value >= 1000) {
      return Math.round(value / 1000) + 'k';
    }

    return value;
  }

}
